:host {
  display: flex;
  flex-direction: column;
  max-width: 100%;
  padding: 0 0 0 calc(var(--spacer) * 2);
}

user-details {
  min-height: var(--single-select-list-content-max-height);
}
